import React from "react";
import { useParams } from "react-router-dom";
import AINewSettingsTabs from "./AINewSettingsTabs";
import SkillControlsPanel from "../../Integrations/SkillControlsPanel";
import ALL_SKILL_DEFS from "../../Integrations/allSkillDefs";

export default function AINewSettingsSkills() {
  const { id } = useParams<{ id: string }>();
  const botId = id ? parseInt(id, 10) : undefined;

  const integrations = Array.from(
    new Set(ALL_SKILL_DEFS.map(s => (s.group ?? "General").split(" — ")[0]))
  ).sort();

  return (
    <div className="flex flex-col">
      <AINewSettingsTabs aiConfigId={id ?? ""} />
      <div className="max-w-4xl mx-auto px-4 pb-12 space-y-6">
        <div className="pt-2 pb-4">
          <h2 className="text-base font-semibold text-slate-800">Bot Skill Controls</h2>
          <p className="text-sm text-slate-500 mt-1">
            Restrict which AI skills this bot can use. These settings layer on top of your
            site-wide defaults — bot overrides can only further restrict skills, never lift a
            site-level disable.
          </p>
          <div className="mt-3 flex flex-wrap gap-2 text-xs text-slate-500">
            <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-slate-100">
              <span className="w-3 h-3 rounded-sm bg-green-100 border border-green-300 inline-block" />
              Follow site defaults
            </span>
            <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-slate-100">
              <span className="w-3 h-3 rounded-sm bg-amber-100 border border-amber-300 inline-block" />
              Ask visitor first
            </span>
            <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-slate-100">
              <span className="w-3 h-3 rounded-sm bg-red-100 border border-red-300 inline-block" />
              Disabled for this bot
            </span>
          </div>
        </div>

        {botId != null && integrations.map(integration => {
          const skills = ALL_SKILL_DEFS.filter(
            s => (s.group ?? "General").split(" — ")[0] === integration
          );
          if (skills.length === 0) return null;
          return (
            <SkillControlsPanel
              key={integration}
              integration={integration.toLowerCase()}
              skills={skills}
              botId={botId}
            />
          );
        })}
      </div>
    </div>
  );
}
